import * as React from "react";
import { connect } from "react-redux";


import { CollectiveInvoices, CollectiveInvoice,
    CollectiveInvoiceStatus } from "../../../../../store/CollectiveInvoice/Types";
import { PageTabs } from "../../../../../store/AppDisplays";
import { validSelectedRow } from "../../../../utils/Booking";
import { amIChecked, myAmount } from "../../../../utils/ManualBooking";
import { ManualBooking, ManualBookingTypes } from "../../../../../store/ManualBooking/Types";
import { DispatchPropsResults, mapDispatchToPropsResults,
    mapStateToPropsResults, StatePropsResults } from "../ManualBookings/Create/Results";
import { bookingBarData, FormBarSize, ManualBookBar } from "../ManualBookings/Create/ManualBookBar";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { formatDate } from "../../../../../utils/DateFormat";
import { CreditDebitIndicator } from "../../../../../store/Statements/Types";
import { canDownloadFile } from "../../../../utils/FileDownload";
import { CollectiveInvoiceStatusTypeDisplay } from "../../../../../store/CollectiveInvoice/Displays";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { ThemeBreakpoints, ThemePalette, ThemePaletteState } from "@vwpfs/mary-air-lib/theme/_Types";
import { Currency } from "@vwpfs/mary-air-lib/components/air/05-atoms/CurrencyDisplay";
import { getCollectiveInvoiceStatusColor } from "../../../../utils/FormatHelpers";
import { DownloadButtonCell } from "../../../06-molecules/DownloadButtonCell";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { RowData, Table } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Checkbox } from "@vwpfs/mary-air-lib/components/air/05-atoms/Checkbox";
import { Icon } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface State {
    selectedRows: ManualBooking[];
}

/**
 *
 */
interface OwnProps {
    results: CollectiveInvoices;
    currentTab?: PageTabs;
}

/**
 *
 */
type Props = OwnProps & StatePropsResults & DispatchPropsResults;

/**
 *
 */
export class ResultsComp
    extends React.Component<Props, State> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.state = this.refreshedRowState();
        this.handlePageClick = this.handlePageClick.bind(this);
        this.submit = this.submit.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
        this.refreshedRowState = this.refreshedRowState.bind(this);
        this.selectItem = this.selectItem.bind(this);
    }

    /**
     *
     */
    public componentDidUpdate(prevProps: Props) {
        if (prevProps.results !== this.props.results) {
            this.setState(this.refreshedRowState());
            return;
        }
    }

    /**
     *
     */
    public render() {
        const calcBookingBarData = bookingBarData(this.props.manualBookings, this.state.selectedRows);

        return (
            <Form onSubmit={this.submit} isValid={calcBookingBarData.isValid === true} >
                <ManualBookBar
                    title={"Free booking"}
                    size={this.props.sidebarCollapsed ? FormBarSize.WITH_COLLAPSED_SIDEBAR : undefined}
                    {...calcBookingBarData}
                />
                <Table
                    hasActions
                    data={{
                        columns: this.resultsData().columns,
                        rows: this.resultsData().rows,
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        sort: this.resultsData().sort,
                    }}
                />
                {(this.props.results.totalPages && this.props.results.totalPages > 1) ?
                    <Container
                        className="scl-h-text-align--center"
                        theme={{
                            padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                        }}
                    >
                        <Pagination
                            pageCount={this.props.results.totalPages}
                            currentPage={this.props.results.number}
                            onPageChange={this.handlePageClick}
                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                        />
                    </Container> : null}
            </Form>
        );
    }

    private handlePageClick(skip: number) {
        this.props.loadResults(skip);
    }

    private submit() {
        this.props.openBookRequest(
            "collective-invoices-free-booking", () =>
                this.props.manualBook(this.props.manualBooking));
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results.content.map((row, index) => {
            const isLoading = ((this.props.fileDownloadResult && this.props.fileDownloadResult.id === row.messageId)
                && this.props.loadingFileDownload);
            return ({
                id: row.id,
                themePalleteState: validSelectedRow(- row.balance, myAmount(row.id, this.state.selectedRows))
                    ? undefined : ThemePaletteState.DANGER,
                tooltip: validSelectedRow(- row.balance,
                    myAmount(row.id, this.state.selectedRows)) ? undefined : "The selected balance is not valid",
                data: [
                    row.status === CollectiveInvoiceStatus.UNPAID
                        || row.status === CollectiveInvoiceStatus.REVERSED
                        || row.status === CollectiveInvoiceStatus.PARTIALLY_PAID ?
                        (
                            <div
                                className="scl-row-selection"
                                style={{
                                    display: "inline-flex",
                                    flexDirection: "row",
                                    flexGrow: 0,
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    className="scl-row-selection__checkbox"
                                    style={{
                                        flex: 1,
                                        flexGrow: 0,
                                        marginRight: "5px",
                                    }}
                                >
                                    <Checkbox
                                        checked={amIChecked(row.id, this.state.selectedRows)}
                                        onChange={(value?: boolean) => this.selectItem(value, row
                                            , - row.balance)}
                                    />
                                </div>
                                <div
                                    className="scl-row-selection__input"
                                    style={{
                                        flex: 1,
                                        flexGrow: 0,
                                    }}
                                >
                                    {amIChecked(row.id, this.state.selectedRows) &&
                                        <FormField
                                            type={FieldTypes.Currency}
                                            placeholder="e.g. 100"
                                            onChange={(value?: number | string) => {
                                                this.onChangeAmount(row,
                                                    value ? typeof value === "string"
                                                        ? parseFloat(value) : value : 0);
                                            }}
                                            value={myAmount(row.id, this.state.selectedRows)}
                                        />
                                    }
                                </div>
                            </div>
                        ) : "",
                    row.invoiceNumber,
                    row.invoiceDate ?
                        formatDate(new Date(row.invoiceDate), "DD-MM-YYYY") : "",
                    row.dealerName,
                    row.partner ? (
                        <a href={`/partners/${row.partner.id}`} target="_blank" rel="noopener noreferrer">
                            <span className="scl-a-link scl-b-h scl-b-h6">
                                <Icon name="eye" />&nbsp;&nbsp;{row.partner.partnerNumber}
                            </span>
                        </a>
                    ) : row.partnerNumber,
                    row.mutationDate
                        ? formatDate(new Date(row.mutationDate), "DD-MM-YYYY")
                        : "",
                    (
                        <Badge
                            key={`badge-${row.id}`}
                            theme={{
                                paletteState:
                                    getCollectiveInvoiceStatusColor(row.status),
                            }}
                        >
                            {CollectiveInvoiceStatusTypeDisplay[row.status?.toString()]}
                        </Badge>
                    ),
                    row.creditDebitIndicator === CreditDebitIndicator.DBIT ? "Debit" : "Credit",
                    <Currency value={row.totalAmount?.amount} key={`bookinvoice${index}`} />,
                    (
                        <h6
                            key={`h6-${row.id}`}>
                            <Currency
                                value={row.balance}
                            />
                        </h6>
                    ),
                    <ButtonsWrapper
                        key={`navlink-${index}`}
                        asGroup
                        alignment={Alignment.RIGHT}
                        defaultOrientation={Orientation.HORIZONTAL}
                        orientations={{
                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                        }}
                    >{
                            row.messageId ? (
                                <DownloadButtonCell
                                    isLoading={isLoading}
                                    loadDownload={() => this.props.loadDownload(row.messageId)}
                                    canDownloadFile={canDownloadFile(this.props)}
                                />
                            ) : ""}</ButtonsWrapper>,
                ],
            });
        });
    }

    /**
     *
     */
    private resultsData() {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Select",
                },
                {
                    label: "Number",
                },
                {
                    label: "Date",
                },
                {
                    label: "Partner name",
                },
                {
                    label: "Partner number",
                },
                {
                    label: "Mutation date",
                },
                {
                    label: "Status",
                },
                {
                    label: "Mutation type",
                },
                {
                    label: "Amount",
                },
                {
                    label: "Balance",
                    alignRight: true,
                },
                {
                    label: "Actions",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }

    private refreshedRowState(): State {
        return {
            selectedRows: this.props.manualBookings ? this.props.manualBookings
                .filter(mB => (mB.objectType === this.props.bookingType) &&
                        (this.props.results.content.some(row => row.id === mB.objectId)))
                .map((mB): ManualBooking => ({
                    objectId: mB.objectId,
                    description: mB.description ? mB.description : "",
                    amount: mB.amount,
                    objectType: this.props.bookingType,
                })) : [],
        };
    }

    private selectItem(value: boolean | undefined, row: CollectiveInvoice, amount: number) {
        this.setState({
            selectedRows: !!value
                ? [...this.state.selectedRows.filter((sR) => (sR.objectId !== row.id
                    && sR.objectType === this.props.bookingType)), {
                    objectId: row.id,
                    amount: amount,
                    description: row.invoiceNumber,
                    objectType: this.props.bookingType,
                }] : this.state.selectedRows.filter((sR) => sR.objectId !== row.id
                    && sR.objectType === this.props.bookingType),
        }, !!value
            && validSelectedRow(- row.balance, amount)
            ? this.onAddSelection : () => this.props.deleteManualBookingRow(row.id));
    }

    private onChangeAmount = (row: CollectiveInvoice, value: number) => {
        const manualBookingEntry = this.state.selectedRows.find(mB => (mB.objectId === row.id
                && mB.objectType === this.props.bookingType));

        this.setState({
            selectedRows: manualBookingEntry ? this.state.selectedRows.map(sR => {
                if (sR.objectId === row.id && sR.objectType === this.props.bookingType) {
                    return ({
                        objectId: sR.objectId,
                        amount: value,
                        description: sR.description,
                        objectType: this.props.bookingType,
                    });
                }

                return sR;
            }) : [...this.state.selectedRows, {
                objectId: row.id,
                amount: value,
                objectType: this.props.bookingType,
                description: row.invoiceNumber,
            }],
        }, validSelectedRow(- row.balance, value) ? this.onAddSelection
            : () => this.props.deleteManualBookingRow(row.id));
    };

    private onAddSelection = () => {
        this.props.addManualBookSelection(this.state.selectedRows);
    };
}

/**
 *
 */
export const Results = connect(
    mapStateToPropsResults,
    mapDispatchToPropsResults(RemoteScope.COLLECTIVE_INVOICE_RESULTS, ManualBookingTypes.COLLECTIVE_INVOICE),
)(ResultsComp);
